import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n'; // Import the multi-language configuration
import App from './App';
import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter } from "react-router-dom";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import theme from "./theme";
import Slide from "@mui/material/Slide";
import ScreenSizeProvider from "./services/ScreenSizeProvider";


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <ScreenSizeProvider>
                    <React.StrictMode>
                        <App />
                    </React.StrictMode>
                </ScreenSizeProvider>
            </ThemeProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);